
import { IRoleOptionsItem } from '../../types/common';
import { IAddAgentUser, IAgentEditDataPermission, IAgentParam, IAgentUser, IUpdateAgentDataPermission } from '../../types/user-center/agent';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 用户中心 - 代理商用户数据查询
 */
export async function queryAgentUsers(param: IAgentParam) {
  let data = [] as IAgentUser[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IAgentParam;

  try {
    const { code, context, message } = await Http.post<{ data: IAgentUser[]; total: number }>(`${hostUrl}/iam/identity/agent/page`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IAgentUser[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}
/**
 * 用户中心 - 代理商用户 - 角色列表
 */
export async function queryAgentRoleList(agentId?: number, isDisplay?: boolean) {
  let data = [] as IRoleOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IRoleOptionsItem>>(`${hostUrl}/iam/role/agent/list`, {
      agentId,
      isDisplay,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 代理商用户 - 新增用户
 */
export async function addAgentUsers(param: IAddAgentUser) {
  let data = {} as { warnCode: number; extra: { name: string }};

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/iam/identity/agent`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 代理商用户 - 查询用户详情
 */
export async function queryAgentAuth(identityId: number) {
  let data = {} as IAgentEditDataPermission;

  try {
    const { code, context, message } = await Http.get<IAgentEditDataPermission>(`${hostUrl}/iam/identity/agent/auth`, { identityId });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 代理商用户 - 更新数据权限
 */
export async function updateAgentAuth(params: IUpdateAgentDataPermission) {

  try {
    const { code, message } = await Http.put<IUpdateAgentDataPermission>(`${hostUrl}/iam/identity/agent/auth`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
